// This file is auto-generated by scripts/generate-version.js
// Do not edit manually - it will be overwritten on build

export const version = {
  gitCommit: '9cbf8c135',
  buildTime: '2026-11-04T21:15:26.523Z',
} as const;
